import { Post } from '@/@types/post'
import { createContext, useContext } from 'react'

interface PostActionsContextValue {
	refresh?: () => Promise<unknown>
	onComment?: (post: Post) => void
}

export const PostActionsContext = createContext<PostActionsContextValue>({})

export const PostActionsProvider = PostActionsContext.Provider
export const usePostActionsContext = () => useContext(PostActionsContext)
